import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import basicdata from './modules/basicdata'
import mygoods from './modules/mygoods'
import mygossips from './modules/mygossips'
import mytasks from './modules/mytasks'
import myrents from './modules/myrents'
import mygamedatas from './modules/mygamedatas'
import sortdatas from './modules/sortdatas'
import pagehistory from './modules/pagehistory'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
    token (state) {
      // state下的user模块下的userInfo里的token
      return state.user.user.authorization
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    basicdata,
    mygoods,
    mygossips,
    mytasks,
    myrents,
    mygamedatas,
    sortdatas,
    pagehistory
  }
})
